import { ApplicationNote } from "../models/ApplicationNote";
import { AddApplicationNoteRequest } from "../models/requests/AddApplicationNoteRequest";
import apiClient from "./api-client";
import { handleApiError } from "./error-handler";

/**
 * Create a new note
 * @param addApplicationNoteRequest The note data to create
 * @param userId The user ID to include in the header
 */
export const createApplicationNote = async (
	addApplicationNoteRequest: AddApplicationNoteRequest
): Promise<ApplicationNote> => {
	try {
		const response = await apiClient.post(
			"/application-notes",
			addApplicationNoteRequest
		);

		return response.data;
	} catch (error: any) {
		throw handleApiError(error, "Failed to create note");
	}
};

/**
 * Get all notes
 * @param userId The user ID to include in the header
 */
export const GetAllNotesOfSpecificApplication = async (
	freelancerOnboardingId: number
): Promise<ApplicationNote[]> => {
	try {
		const response = await apiClient.get(
			`/application-notes?freelancerOnboardingId=${freelancerOnboardingId}`
		);

		return response.data;
	} catch (error: any) {
		throw handleApiError(error, "Failed to fetch notes");
	}
};

/**
 * Get the latest note
 * @param userId The user ID to include in the header
 */
export const GetLatestNoteOfSpecificApplication = async (
	freelancerOnboardingId: number
): Promise<ApplicationNote> => {
	try {
		const response = await apiClient.get(
			`/application-notes/latest?freelancerOnboardingId=${freelancerOnboardingId}`
		);

		return response.data;
	} catch (error: any) {
		throw handleApiError(error, "Failed to fetch latest note");
	}
};
